import './Home.css';
import React from 'react';
import Navbar from '../../Shared/Navbar/Navbar';
import HeroSection from '../HeroSection/HeroSection';
import Portfolio from '../Portfolio/Portfolio';
import Expertise from '../Expertise/Expertise';
import Blogs from '../../Blogs/Blogs';
import Footer from '../../Shared/Footer/Footer';
import Contact from '../Contact/Contact';

const Home = () => {
      return (
            <main className='main-container'>
                  <Navbar />
                  <HeroSection />
                  <Portfolio/>
                  <Expertise />
                  <Blogs />
                  <Contact />
                  <Footer />
            </main>
      );
};

export default Home;